module.exports = __webpack_public_path__ + "img/tree-chevron.13c04f0a.svg";